import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from '@els/els-react--button';
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import UserDatabases from '@Services/UserDatabases';

import './ResultsFiltersButtons.scss';

async function runAction(event, action, onComplete) {
  const trigger = event.currentTarget;
  const focusStartedOnTrigger = document.activeElement === trigger;
  const result = await action();
  const { activeElement } = document;

  // An applied filter can replace this entire CTA surface. Restore focus only when the action
  // owned it and the user has not deliberately moved elsewhere while the request was running.
  const shouldRestoreFocus = focusStartedOnTrigger && (activeElement === trigger || activeElement === document.body);
  onComplete?.({ result, shouldRestoreFocus });
}

export default function ResultsFiltersButtons(props) {
  const { className, databaseId, limitTo, exclude, clear, disableButtons, onApplyComplete, onClearComplete } = props;
  const isExcludeButtonHidden = UserDatabases.isRCSDatabase(databaseId) && Auth.isFeatureEnabled(FEATURES.hideRCSFiltersExcludeButton);

  return (
    <div
      className={classnames(
        'u-els-padding-top u-els-padding-bottom o-els-flex-layout o-els-flex-layout--space-between results-filters-buttons',
        className
      )}>
      <div className="filter-buttons-left">
        <Button
          data-e2e="results-filters-limit"
          type="primary"
          size="small"
          onClick={(event) => runAction(event, limitTo, onApplyComplete)}
          disabled={disableButtons}
          className="e2e-results-filters-limit">
          Limit to
        </Button>
        {!isExcludeButtonHidden && (
          <Button
            data-e2e="results-filters-exclude"
            type="secondary"
            size="small"
            onClick={(event) => runAction(event, exclude, onApplyComplete)}
            disabled={disableButtons}
            className="e2e-results-filters-exclude">
            Exclude
          </Button>
        )}
      </div>
      <Button
        data-e2e="results-filters-clear"
        type="borderless"
        size="small"
        onClick={(event) => runAction(event, clear, onClearComplete)}
        disabled={disableButtons}
        className="u-els-color-linkblue e2e-results-filters-clear">
        Clear
      </Button>
    </div>
  );
}

const propTypes = {
  className: PropTypes.string,
  databaseId: PropTypes.string.isRequired,
  limitTo: PropTypes.func.isRequired,
  exclude: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
  disableButtons: PropTypes.bool.isRequired,
  onApplyComplete: PropTypes.func,
  onClearComplete: PropTypes.func,
};

ResultsFiltersButtons.propTypes = propTypes;
